export const getUserData = (id, users) => {
  return users?.filter((data) => data._id == id)?.[0] || null;
};
